import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const AppDevelopmentPage = lazy(() => import('../pages/services/app-development/page'));
const QAServicesPage = lazy(() => import('../pages/services/qa-services/page'));
const DevOpsPage = lazy(() => import('../pages/services/devops/page'));
const ApplicationSecurityPage = lazy(() => import('../pages/services/application-security/page'));
const CloudSecurityPage = lazy(() => import('../pages/services/cloud-security/page'));
const VAPTPage = lazy(() => import('../pages/services/vapt/page'));
const DataSecurityPage = lazy(() => import('../pages/services/data-security/page'));
const IdentityAccessManagementPage = lazy(() => import('../pages/services/identity-access-management/page'));
const SOCPage = lazy(() => import('../pages/services/soc/page'));
const MSSPPage = lazy(() => import('../pages/services/mssp/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const ThankYouPage = lazy(() => import('../pages/thank-you/page'));

// Blog Pages
const SecureMobileAppsPage = lazy(() => import('../pages/blog/secure-mobile-apps/page'));
const DevSecOpsPipelinePage = lazy(() => import('../pages/blog/devsecops-pipeline/page'));
const MultiCloudSecurityPage = lazy(() => import('../pages/blog/multi-cloud-security/page'));
const VAPTSecurityTestingPage = lazy(() => import('../pages/blog/vapt-security-testing/page'));
const IAMZeroTrustPage = lazy(() => import('../pages/blog/iam-zero-trust/page'));
const SOCContinuousMonitoringPage = lazy(() => import('../pages/blog/soc-continuous-monitoring/page'));
const DataSecurityPracticesPage = lazy(() => import('../pages/blog/data-security-practices/page'));
const AutomatedTestingQAPage = lazy(() => import('../pages/blog/automated-testing-qa/page'));
const MSSPEnterpriseSecurityPage = lazy(() => import('../pages/blog/mssp-enterprise-security/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services/app-development',
    element: <AppDevelopmentPage />,
  },
  {
    path: '/services/qa-services',
    element: <QAServicesPage />,
  },
  {
    path: '/services/devops',
    element: <DevOpsPage />,
  },
  {
    path: '/services/application-security',
    element: <ApplicationSecurityPage />,
  },
  {
    path: '/services/cloud-security',
    element: <CloudSecurityPage />,
  },
  {
    path: '/services/vapt',
    element: <VAPTPage />,
  },
  {
    path: '/services/data-security',
    element: <DataSecurityPage />,
  },
  {
    path: '/services/identity-access-management',
    element: <IdentityAccessManagementPage />,
  },
  {
    path: '/services/soc',
    element: <SOCPage />,
  },
  {
    path: '/services/mssp',
    element: <MSSPPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/thank-you',
    element: <ThankYouPage />,
  },
  {
    path: '/blog/secure-mobile-apps',
    element: <SecureMobileAppsPage />,
  },
  {
    path: '/blog/devsecops-pipeline',
    element: <DevSecOpsPipelinePage />,
  },
  {
    path: '/blog/multi-cloud-security',
    element: <MultiCloudSecurityPage />,
  },
  {
    path: '/blog/vapt-security-testing',
    element: <VAPTSecurityTestingPage />,
  },
  {
    path: '/blog/iam-zero-trust',
    element: <IAMZeroTrustPage />,
  },
  {
    path: '/blog/soc-continuous-monitoring',
    element: <SOCContinuousMonitoringPage />,
  },
  {
    path: '/blog/data-security-practices',
    element: <DataSecurityPracticesPage />,
  },
  {
    path: '/blog/automated-testing-qa',
    element: <AutomatedTestingQAPage />,
  },
  {
    path: '/blog/mssp-enterprise-security',
    element: <MSSPEnterpriseSecurityPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;